import { useSyncExternalStore } from 'react';

import { type Action, can } from '@/config/access';
import {
  activeMembership,
  getSession,
  getSessionEnd,
  type Membership,
  type Session,
  type SessionEnd,
  subscribe,
} from './session';

/** Returns what ended the last session, or null once a new one starts. */
export function useSessionEnd(): SessionEnd | null {
  return useSyncExternalStore(subscribe, getSessionEnd, () => null);
}

/** Returns the stored session, or null without one. */
export function useSession(): Session | null {
  return useSyncExternalStore(subscribe, getSession, () => null);
}

/** Returns the selected organization, the scope of every Firestore path and API call. */
export function useActiveOrganizationId(): string | null {
  return useSession()?.organizationId ?? null;
}

/** Returns the membership of the selected organization, or null without one. */
export function useActiveMembership(): Membership | null {
  return activeMembership(useSession());
}

/** Returns true when the active membership may do the action. */
export function useCan(action: Action): boolean {
  return can(useActiveMembership(), action);
}
